var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.004,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 46.549,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 93.091,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 139.641,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M512,232.731H8c-4.418,0-8-3.582-8-8v-38.545h512V232.731z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "512,279.277 0,279.277 0,215.582 13.471,215.582 13.474,232.731 512,232.731 "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 279.271,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 325.821,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 372.361,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 418.911,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 465.451,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 46.545
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.004,
    style: {
      fill: "#41479B"
    },
    width: 229.05,
    height: 232.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M110.677,60.234L97.813,98.805L57.155,99.12c-3.899,0.03-5.516,5.006-2.379,7.322l32.708,24.153  L75.22,169.36c-1.176,3.717,3.056,6.793,6.229,4.525l33.078-23.643l33.078,23.643c3.172,2.267,7.405-0.808,6.229-4.525  l-12.264-38.765l32.708-24.153c3.137-2.316,1.52-7.292-2.379-7.322l-40.658-0.315l-12.865-38.571  C117.142,56.535,111.91,56.535,110.677,60.234z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/LR.39e73cdf47d766429f40fbc9c4046278.svg";
export { ForwardRef as ReactComponent };